module.exports = __webpack_public_path__ + "static/media/home-slider-banner-4.fa7fb55b.png";